// router.js
import Vue from 'vue';
import Router from 'vue-router';
import Record from './components/index.vue';
import statistics from './components/statistics.vue';
import sleep from './components/sleep.vue';
import other from './components/other.vue';
import sport from './components/sport.vue';
import foodMenu from './components/foodMenu.vue';
import todayEat from './components/todayEat.vue';
import memorandum from './components/memorandum.vue';
import english from './components/english.vue';
import IpList from './components/ipSave.vue';
import loseWeight from './components/loseWeight.vue';
import baking from './components/baking.vue';
import charge from './components/charge.vue';
import miaotixing from './components/miaotixing.vue';
import homeMemory from './components/homeMemory.vue';
import deviceKey from './components/deviceKey.vue';
import accountVault from './components/accountVault.vue';
import login from './components/login.vue';
import store from './store';

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(Router);

const router = new Router({
    routes: [
        {
            path: '/login',
            name: 'login',
            component: login
        },
        {
            path: '/miaotixing',
            name: 'miaotixing',
            component: miaotixing
        },
        {
            path: '/charge',
            name: 'charge',
            component: charge
        },
        {
            path: '/loseWeight',
            name: 'loseWeight',
            component: loseWeight
        },
        {
            path: '/baking',
            name: 'Baking-Com',
            component: baking
        },
        {
            path: '/IpList',
            name: 'IpList',
            component: IpList
        },
        {
            path: '/homeMemory',
            name: 'homeMemory',
            component: homeMemory
        },
        {
            path: '/deviceKey',
            name: 'deviceKey',
            component: deviceKey
        },
        {
            path: '/accountVault',
            name: 'accountVault',
            component: accountVault
        },
        {
            path: '/english',
            name: 'english',
            component: english
        },
        {
            path: '/memorandum',
            name: 'memorandum',
            component: memorandum
        },
        {
            path: '/recipes',
            name: 'recipes',
            component: todayEat
        },
        {
            path: '/foodMenu',
            name: 'foodMenu',
            component: foodMenu
        },
        {
            path: '/sport',
            name: 'sport',
            component: sport
        },
        {
            path: '/other',
            name: 'other',
            component: other
        },
        {
            path: '/sleep',
            name: 'sleep',
            component: sleep
        },
        {
            path: '/statistics',
            name: 'statistics',
            component: statistics
        },
        {
            path: '/record',
            name: 'record',
            component: Record
        },
        {
            path: '/',
            name: 'record',
            component: Record
        },
    ]
});

router.beforeEach((to, from, next) => {
    const token = localStorage.getItem('token')
    if (to.path === '/login') {
        if (token) {
            next('/')
        } else {
            next()
        }
        return
    }
    if (!token) {
        next('/login')
        return
    }
    if (!store.state.user) {
        store.dispatch('refreshUser').then((user) => {
            if (!user) {
                next('/login')
            } else {
                next()
            }
        })
        return
    }
    next()
})

export default router